module.exports = __webpack_public_path__ + "assets/img/75f73c7f16a154ddb8f096182c364293.png";